import { useEffect, useState } from "react";

import type { ClientToWorkerMessage } from "./messaging.client";

import { messageSW } from "workbox-window";
const getServiceWorkerVersion = async () => {
  const controller = window.navigator.serviceWorker?.controller;
  if (!controller) {
    return;
  }

  const message: ClientToWorkerMessage = {
    type: "REQUEST_SERVICE_WORKER_VERSION",
  };

  const response = await messageSW(controller, message);
  if (typeof response === "string") {
    return response;
  }
};

export const useServiceWorkerVersion = () => {
  const [serviceWorkerVersion, setServiceWorkerVersion] = useState("Ukjent");

  useEffect(() => {
    if ("serviceWorker" in window.navigator) {
      getServiceWorkerVersion().then((version) => {
        if (version) {
          setServiceWorkerVersion(version);
        }
      });
    }
  }, []);

  return { serviceWorkerVersion };
};
